import { render, staticRenderFns } from "./ModalReward.vue?vue&type=template&id=283cb59a&scoped=true&"
import script from "./ModalReward.vue?vue&type=script&lang=js&"
export * from "./ModalReward.vue?vue&type=script&lang=js&"
import style0 from "./ModalReward.vue?vue&type=style&index=0&id=283cb59a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283cb59a",
  null
  
)

export default component.exports